import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppRouterService {

  private queryParams:any;

  constructor() { }

  setRoutingExtras(extras:NavigationExtras){
    this.queryParams = extras?.queryParams;
  }

  getRoutingParams(){
    return this.queryParams;
  }

  clearRoutingParams(){
    this.queryParams = null;
  }

}
